import moment from 'moment';
import { StudioAction, IStudioState, ReduxStudioActionType } from './model';
import { StudioInitState } from './state';

export const studioReducer = (
  state = StudioInitState,
  action: StudioAction
): IStudioState => {
  switch (action.type) {
    case ReduxStudioActionType.SELECT_STUDIO:
      return { ...state, selectStudio: action.result };
    case ReduxStudioActionType.STUDIO_LIST:
      return {
        ...state,
        studioList: action.result.sort(
          (a, b) => +moment(a.studioCreateTime) - +moment(b.studioCreateTime)
        ),
      };
    case ReduxStudioActionType.SET_CERT:
      return {
        ...state,
        studioCert: { ...state.studioCert, ...action.result },
      };
    default:
      return state;
  }
};
